import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, Upload, CheckSquare, BarChart3, UserCog } from 'lucide-react';
import { cn } from '../../lib/utils';

const tabs = [
  { path: '/dashboard', icon: LayoutDashboard, label: 'Home' },
  { path: '/upload', icon: Upload, label: 'Upload' },
  { path: '/transactions', icon: CheckSquare, label: 'Review' },
  { path: '/reports', icon: BarChart3, label: 'Reporting' },
  { path: '/settings', icon: UserCog, label: 'Account' },
];

export default function BottomTabBar() {
  const { pathname } = useLocation();

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-zinc-200 safe-area-bottom"
      data-testid="bottom-tab-bar"
    >
      <div className="flex justify-around items-center h-14">
        {tabs.map(({ path, icon: Icon, label }) => {
          const active = pathname === path;
          return (
            <NavLink
              key={path}
              to={path}
              data-testid={`bottom-tab-${label.toLowerCase()}`}
              className={cn(
                'flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors',
                active ? 'text-[#D94E18]' : 'text-zinc-400'
              )}
            >
              <Icon className="w-5 h-5" strokeWidth={active ? 2 : 1.5} />
              <span className="text-[10px] font-medium">{label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
